import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayChatIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19 2.25H5C2.38 2.25 0.25 4.38 0.25 7V15C0.25 17.62 2.38 19.75 5 19.75H9.6L11.38 22.42C11.66 22.86 12.35 22.86 12.63 22.42L14.41 19.75H19.01C21.63 19.75 23.76 17.62 23.76 15V7C23.76 4.38 21.63 2.25 19.01 2.25H19ZM22.25 15C22.25 16.79 20.79 18.25 19 18.25H14C13.75 18.25 13.51 18.37 13.38 18.58L12 20.64L10.62 18.58C10.48 18.37 10.25 18.25 10 18.25H5C3.21 18.25 1.75 16.79 1.75 15V7C1.75 5.21 3.21 3.75 5 3.75H19C20.79 3.75 22.25 5.21 22.25 7V15Z"
        fill={color}
      />
      <path
        d="M12.51 9.88H11.5C11.1576 9.88 10.88 10.1576 10.88 10.5V11.51C10.88 11.8524 11.1576 12.13 11.5 12.13H12.51C12.8524 12.13 13.13 11.8524 13.13 11.51V10.5C13.13 10.1576 12.8524 9.88 12.51 9.88Z"
        fill={color}
      />
      <path
        d="M17.63 9.88H16.62C16.2776 9.88 16 10.1576 16 10.5V11.51C16 11.8524 16.2776 12.13 16.62 12.13H17.63C17.9724 12.13 18.25 11.8524 18.25 11.51V10.5C18.25 10.1576 17.9724 9.88 17.63 9.88Z"
        fill={color}
      />
      <path
        d="M7.38 9.88H6.37C6.02758 9.88 5.75 10.1576 5.75 10.5V11.51C5.75 11.8524 6.02758 12.13 6.37 12.13H7.38C7.72242 12.13 8 11.8524 8 11.51V10.5C8 10.1576 7.72242 9.88 7.38 9.88Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayChatIcon.displayName = 'PayChatIcon';
